import {gql} from "@apollo/client";
import {ApolloClientQuery} from "./_setup";

const GET_PN_SERVER_SETTING_WITHOUT_TOKEN = gql`
query getPNServerSettingWithoutToken($input: PNServerSettingWithoutToken!) {
    getPNServerSettingWithoutToken(input: $input) {
        ... on PushNotificationServerSetting {
            _id
            name
            targetPlatform
            provider
            firebase {
                config {
                    apiKey
                    authDomain
                    projectId
                    storageBucket
                    messagingSenderId
                    appId
                    measurementId
                }
                vapid
            }
        }
        ... on BaseError {
            errKey
            errMsg
        }
    }
}
`;

export async function getPNServerSettingWithoutToken(targetPlatform, provider) {
    const variables = {
        input: {
            targetPlatform: targetPlatform,
            provider: provider,
        },
        context: {
            headers: {
                authorization: "Bearer " + localStorage.getItem("a_t"),
            },
        },
    }

    const execute = await ApolloClientQuery(GET_PN_SERVER_SETTING_WITHOUT_TOKEN, variables, false);

    return execute;
}

const UPDATE_USER_PUSH_NOTIFICATION_TOKEN = gql`
mutation updateUserPushNotificationToken($input: PushNotificationTokenInput) {
    updateUserPushNotificationToken(input: $input) {
        ... on PushNotificationToken {
            _id
            user
            platform
            provider
            browser
            os
            device {
                type
                vendor
            }
            token
            isDeleted
            isNewDeviceLogin
        }
        ... on BaseError {
            errKey
            errMsg
        }
    }
}
`;

export async function updateUserPushNotificationToken(input) {

    const variables = {
        input: input,
        context: {
            headers: {
                authorization: "Bearer " + localStorage.getItem("a_t"),
            },
        },
    };
    const execute = await ApolloClientQuery(UPDATE_USER_PUSH_NOTIFICATION_TOKEN, variables, true);

    return execute;
}

const GET_PUSH_NOTIFICATION_LOG_BY_USER_ID = gql`
    query getPushNotificationLogByUserId($id: String, $limit: Int, $offset: Int, $orderBy: String) {
        getPushNotificationLogByUserId(id: $id, limit: $limit, offset: $offset, orderBy: $orderBy) {
            ... on PushNotificationLogWithUnreadArray {
                data {
                    _id
                    user {username}
                    fromTemplate {
                        _id
                        name
                        type
                    }
                    platform
                    isRead
                    status
                    error
                    token
                    notification {
                        title
                        body
                        icon
                        image
                    }
                    longContent
                    createdAt
                    updatedAt
                }
                total
                unreadTotal
            }
            ... on BaseError {
                errKey
                errMsg
                errObj
            }
        }
    }
`

export const getPushNotificationLogByUserId = async (id, limit, offset, orderBy) => {
    try {
        const execute = await ApolloClientQuery(
            GET_PUSH_NOTIFICATION_LOG_BY_USER_ID,
            {
                id: id,
                limit: limit,
                offset: offset,
                orderBy: orderBy,
            },
            false
        );

        return execute;
    } catch (err) {
        console.error(err);
        return {data: null, loading: false, error: err};
    }
};

const UPDATE_PUSH_NOTIFICATION_LOG_READ_STATUS = gql`
    mutation updatePushNotificationLogReadStatus($id: [String]!, $isRead: Boolean!) {
        updatePushNotificationLogReadStatus(id: $id, isRead: $isRead)
    }
`

export const updatePushNotificationLogReadStatus = async (id, isRead) => {
    try {
        const execute = await ApolloClientQuery(
            UPDATE_PUSH_NOTIFICATION_LOG_READ_STATUS,
            {
                id: id,
                isRead: isRead,
            },
            true
        );

        return execute;
    } catch (err) {
        console.error(err);
        return {data: null, loading: false, error: err};
    }
};
